import { unwrapResult } from "@reduxjs/toolkit";
import { useAppDispatch } from "model";
import { getMetabaseUrl } from "model/metabaseUrlSlice";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MetabaseIframe } from "./MetabaseIframe";

export function ProjectInsights() {
  const selectedDashboard = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
    (state) => (state as any).selectedProjectDashboard
  );
  const dispatch = useAppDispatch();
  const [metabaseUrl, setMetabaseUrl] = useState<string>("");
  useEffect(() => {
    if (selectedDashboard && selectedDashboard.guid) {
      const workaroundFunc = async () => {
        const params: { [name: string]: string } = {};
        try {
          const res = await dispatch(
            getMetabaseUrl({
              visualizationId: selectedDashboard.guid,
              params,
            })
          ).then(unwrapResult);
          setMetabaseUrl(res.url);
        } catch (e) {
          console.log(e);
        }
      };
      void workaroundFunc();
    }
  }, [dispatch, selectedDashboard]);
  return <MetabaseIframe metabaseUrl={metabaseUrl}></MetabaseIframe>;
}
